export const REGISTER_PENDING = 'Registro Pendente'
export const REGISTER_FINISHED = 'Registro Finalizado'
export const REGISTER_CANCELED = 'Registro Cancelado'

export const REGISTERS_STATUS = [REGISTER_PENDING, REGISTER_FINISHED, REGISTER_CANCELED]

export const registersStatusProps = {
  [REGISTER_PENDING]: { color: 'yellow-8', name: 'schedule' },
  [REGISTER_FINISHED]: { color: 'positive', name: 'check' },
  [REGISTER_CANCELED]: { color: 'red-6', name: 'close' }
}

export const PENDING = 'Pendente'
export const PROGRESS = 'Em Execução'
export const COMPLETED = 'Concluído'
export const CANCELED = 'Cancelado'
export const REJECTED = 'Rejeitado'
export const SENT = 'Enviado'
export const LATE = 'Atrasado'
export const WAITING = 'Aguardando'
export const REPLIED = 'Respondido'
export const POSTPONED = 'Postergado'
/** Exclusivo da Assinatura Digital na Receita: todos os sócios assinaram, falta o analista concluir */
export const SIGNED = 'Assinado'

export const registersStepsStatus = [PENDING, PROGRESS, COMPLETED, CANCELED, REJECTED, SENT, LATE, WAITING, REPLIED, POSTPONED, SIGNED]

export const registersStepsStatusProps = {
  [PENDING]: { color: 'yellow-8', name: 'schedule' },
  [PROGRESS]: { color: 'cyan', name: 'autorenew' },
  [COMPLETED]: { color: 'positive', name: 'check' },
  [CANCELED]: { color: 'grey', name: 'close' },
  [REJECTED]: { color: 'red-6', name: 'block' },
  [SENT]: { color: 'indigo-5', name: 'mark_email_read' },
  [LATE]: { color: 'red-6', name: 'watch_later' },
  [WAITING]: { color: 'teal-4', name: 'watch_later' },
  [REPLIED]: { color: 'blue-grey-13', name: 'assignment' },
  [POSTPONED]: { color: 'purple-4', name: 'timer' },
  [SIGNED]: { color: 'teal-5', name: 'draw' }
}

export const MINUTA = 'draft'
export const VIABILIDADE = 'viability'
export const RECEITA_FEDERAL = 'irs'
export const INSCRICAO_JUNTA = 'board_registration'
export const TAXA_JUNTA = 'board_fee'
export const ASSINATURA_DIGITAL = 'digital_signature'
export const ASSINATURA_DIGITAL_MAT = 'digital_signature_mat'
export const PROTOCOLO = 'protocol'
export const SIMPLES_NACIONAL = 'national_simple'

/** Labels for steps removed from the active timeline but still present in history */
export const REMOVED_STEPS_LABELS = {
  [SIMPLES_NACIONAL]: 'Solicitação do Simples'
}

export const steps = [
  MINUTA,
  VIABILIDADE,
  RECEITA_FEDERAL,
  INSCRICAO_JUNTA,
  TAXA_JUNTA,
  ASSINATURA_DIGITAL,
  PROTOCOLO,
  ASSINATURA_DIGITAL_MAT
]

export const stepsProps = {
  [MINUTA]: {
    label: 'Minuta',
    homeLabel: 'Elaboração da Minuta Contratual',
    description: 'Nessa etapa, elaboramos a Minuta Contratual, que é a "certidão de nascimento" da sua empresa. Ela contém informações pessoais do(s) sócio(s), bem como cláusulas obrigatórias e particulares que traduzem as diretrizes do negócio. É importante conferir todos os dados antes de seguir para as próximas etapas.',
    statusOptions: [PENDING, PROGRESS, WAITING, COMPLETED, CANCELED, REJECTED, POSTPONED]
  },
  [VIABILIDADE]: {
    label: 'Viabilidade',
    homeLabel: 'Consulta de Viabilidade na Junta Comercial',
    description: 'Aqui iniciamos a consulta de viabilidade no site da Junta Comercial do respectivo Estado.',
    statusOptions: [PENDING, PROGRESS, COMPLETED, CANCELED, REJECTED]
  },
  [RECEITA_FEDERAL]: {
    label: 'Receita Federal',
    homeLabel: 'Cadastro na Receita Federal',
    description: 'Nessa etapa, preenchemos um documento denominado DBE (Documento Básico de Entrada) com informações complementares para a Receita Federal.',
    statusOptions: [PENDING, PROGRESS, COMPLETED, CANCELED, REJECTED]
  },
  [INSCRICAO_JUNTA]: {
    label: 'Inscrição na Junta',
    homeLabel: 'Inscrição na Junta Comercial',
    description: 'Nesse etapa, preenchemos a FCN (Ficha de Cadastro Nacional), onde informamos informações dos sócios para a Junta Comercial. Com isso, será possível dar andamento no processo de abertura da sua empresa.',
    statusOptions: [PENDING, PROGRESS, COMPLETED, CANCELED, REJECTED]
  },
  [TAXA_JUNTA]: {
    label: 'Taxa da Junta',
    homeLabel: 'Pagamento da Taxa da Junta Comercial',
    description: 'Nessa etapa, é necessário que você pague o boleto da Taxa da Junta Comercial, que é o valor cobrado pela Junta Comercial por ter gerado o Número de Identificação de Registro da sua Empresa (principal documento para conseguir obter um CNPJ).',
    statusOptions: [PENDING, SENT, LATE, COMPLETED, CANCELED]
  },
  [ASSINATURA_DIGITAL]: {
    label: 'Assinatura Digital na Junta',
    homeLabel: 'Assinatura Digital na Junta',
    description: 'Nessa etapa, será preciso assinar digitalmente a Minuta Contratual, elaborada no início do processo. Para isso, é utilizado certificado digital do tipo A1, A3 ou em nuvem (exemplos: bird id, vidaas).',
    statusOptions: [PENDING, SENT, COMPLETED, CANCELED]
  },
  [PROTOCOLO]: {
    label: 'Protocolo',
    homeLabel: 'Protocolação',
    description: 'Agora é só aguardar a análise da Junta Comercial!',
    statusOptions: [PENDING, WAITING, COMPLETED, REJECTED]
  },
  [ASSINATURA_DIGITAL_MAT]: {
    label: 'Assinatura Digital na Receita',
    homeLabel: 'Assinatura Digital na Receita',
    description: 'Nessa etapa, será feita a escolha do regime tributário. E o cartão CNPJ será emitido após sua assinatura digital, exclusivamente via acesso do GOV.BR.',
    statusOptions: [PENDING, SENT, SIGNED, COMPLETED, CANCELED]
  }
}

export const getStepLabel = (step) => stepsProps[step]?.label || REMOVED_STEPS_LABELS[step] || '-'

/**
 * Status exibido ao sócio: após ele assinar, a etapa fica verde na visão dele,
 * enquanto para o analista permanece Enviado até a conclusão manual.
 */
export const getPartnerStepStatus = (step) => {
  if (!step) return PENDING

  const hasSigned = step.key === ASSINATURA_DIGITAL_MAT
    ? step.answered_digital_signature_mat
    : step.key === ASSINATURA_DIGITAL && step.answered_digital_signature

  if (hasSigned) return COMPLETED

  // Assinado é o status coletivo da etapa; quem ainda não assinou continua vendo a pendência
  return step.status === SIGNED ? SENT : step.status
}

export const getIconProps = (status, step) => {
  if (status === REJECTED) return { color: 'red-6', icon: 'warning' }
  if (step === TAXA_JUNTA && status === SENT) return { color: 'red-6', icon: 'monetization_on' }
  if (step === TAXA_JUNTA && status === LATE) return { color: 'red-6', icon: 'monetization_on' }
  if (step === ASSINATURA_DIGITAL && status === SENT) return { color: 'red-6', icon: 'draw' }
  if (step === ASSINATURA_DIGITAL_MAT && status === SENT) return { color: 'red-6', icon: 'draw' }

  const statusProps = registersStepsStatusProps[status]

  return { color: statusProps.color, icon: statusProps.name }
}

export const REGISTER_DOCS_TYPES = [
  { name: 'contrato_social', label: 'Contrato Social', required: true },
  { name: 'alteracoes_contratuais', label: 'Outras alterações contratuais', required: false },
  { name: 'cartao_cnpj', label: 'Cartão CNPJ', required: true }
]

export const DEFAULT_PARTNER = {
  name: '',
  nationality: 'brasileiro (a)',
  marital_status: '',
  matrimonial_regime: null,
  profession: 'médico (a)',
  birth_city: '',
  birth_date: '',
  cpf: '',
  rg: '',
  issuing_uf_rg: '',
  issuing_agency: '',
  issuing_date_rg: '',
  address: {
    cep: '',
    state: '',
    city: '',
    neighborhood: '',
    street: '',
    number: '',
    state_id: null,
    city_id: null
  }
}

export const DEFAULT_CNAES = [
  {
    code: '8630-5/03',
    text: 'Atividade médica ambulatorial restrita a consultas'
  },
  {
    code: '8630-5/01',
    text: 'Atividade médica ambulatorial com recursos para realização de procedimentos cirúrgicos'
  },
  {
    code: '8630-5/99',
    text: 'Atividades médicas em unidades hospitalares e consultórios de terceiros'
  },
  {
    code: '8610-1/01',
    text: 'Atividades de atendimento hospitalar, exceto pronto socorro e unidades para atendimento a urgências'
  },
  {
    code: '8610-1/02',
    text: 'Atividades de atendimento em pronto socorro e unidades hospitalares para atendimento a urgências;'
  }
]

export const DEFAULT_SHARE_CAPITAL = 1500

export const DEFAULT_SHARES = 150

export const DEFAULT_MINUTA = {
  doctors: [],
  equal_division: true,
  company_name: '',
  address: {
    cep: '',
    state: '',
    city: '',
    neighborhood: '',
    street: '',
    number: '',
    complement: '',
    city_id: null,
    state_id: null
  },
  cnaes: [],
  company: {
    share_capital: DEFAULT_SHARE_CAPITAL,
    shares: DEFAULT_SHARES
  }
}

export const MAX_COMMENT_FIELD_LENGTH = 1000

export const TYPE_STATUS_CHANGE = 'Alteração de Status'
export const TYPE_RESPONSIBLE_CHANGE = 'Alteração de Responsável'
export const TYPE_START_REGISTER = 'Início do Registro'
export const TYPE_CONCLUDED_REGISTER = 'Conclusão do Registro'
export const TYPE_CANCEL_REGISTER = 'Cancelamento do Registro'
export const TYPE_PENDING_REGISTER = 'Retomada do Registro'
export const TYPE_UPDATE_DUE_DATE = 'Atualização da Data de Vencimento'
export const TYPE_SEND_DIGITAL_SIGNATURE_NOTIFICATION = 'Envio da notificação da Assinatura Digital'
export const TYPE_SEND_DIGITAL_SIGNATURE_MAT_NOTIFICATION = 'Envio da notificação da Assinatura Digital MAT'
export const TYPE_PARTNER_SIGNATURE = 'Assinatura do Sócio'
